module.exports = __webpack_public_path__ + "6dd6029d71589587a1aa901bc92c2cfa.png";